import React from "react";
import { useEqualWidth } from "@Helpers/EqualWidth";
export default function FileName(props) {
    const reference = useEqualWidth("filename", []);
    return React.createElement("span", { ref: reference }, props.children);
}
